import { render, staticRenderFns } from "./CalendarEventCard.vue?vue&type=template&id=30e2c93a&scoped=true&"
import script from "./CalendarEventCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarEventCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CalendarEventCard.vue?vue&type=style&index=0&id=30e2c93a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e2c93a",
  null
  
)

export default component.exports